
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/deals/[shop]",
      function () {
        return require("private-next-pages/deals/[shop]/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/deals/[shop]"])
      });
    }
  